import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { List, Datagrid, DateField, TextField, Filter, ReferenceInput, AutocompleteInput, TextInput, SelectInput } from 'react-admin';
// import { unparse as convertToCSV } from 'papaparse/papaparse.min';
// import moment from 'moment';

const DigitalOrdersFilter = ({ permissions, ...props }) => (
    <Filter {...props}>
        <ReferenceInput label="Customer Name" source="business_id" reference="businesses" linkType="show" allowEmpty>
            <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput label="Transaction Number" source="order_timestamp" />
        <TextInput label="Product" source="product_type" />
        <SelectInput source="mode_of_delivery" choices={[
            { id: 'self_collect', name: 'Self Collect' },
            { id: 'delivered', name: 'Delivered' },
        ]} />
        <TextInput label="Sales Order Number" source="logon_order_no" />
        <TextInput source="shipment_number" />
        <TextInput source="load_number" />
        <ReferenceInput label="Delivery Site" source="sap_business_site_id" reference="sap_business_sites" linkType="show" allowEmpty>
            <AutocompleteInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

// const cardActionStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const ListActions = ({
//     displayedFilters,
//     filters,
//     filterValues,
//     resource,
//     showFilter,
//     exporter,
//     currentSort,
//     total,
// }) => (
//     <TopToolbar style={cardActionStyle}>
//         {filters && React.cloneElement(filters, {
//             resource,
//             showFilter,
//             displayedFilters,
//             filterValues,
//             context: 'button',
//         }) }
//         <RefreshButton />
//         <ExportButton
//             disabled={total === 0}
//             resource={resource}
//             sort={currentSort}
//             filter={filterValues}
//             exporter={exporter}
//         />
//     </TopToolbar>
// )

// const digitalOrdersExporter = (digitalOrders) => {
//     const ordersForExport = digitalOrders.map(order => {
//         console.log('order', order);
//         // add a field from an embedded resource
//         order.expected_date = `${moment(order.delivery_date_from).format('DD/MM/YYYY')} - ${moment(order.delivery_date_from).add(2, 'days').format('DD/MM/YYYY')}`;
//         order.order_date = moment(order.creation_date).format('DD/MM/YYYY, H:MM:SS A')
//         return order;
//     });
//     const csv = convertToCSV({
//         data: ordersForExport,
//         fields: ['order_date', 'business_id', 'order_number', 'mode_of_delivery', 'expected_date', 'customer_ref_number', 'customer_order_status_desc', 'sap_business_site_id'] // select and order fields in the export
//     });
//     downloadCSV(csv, 'digitalOrders'); // download as 'digitalOrders.csv` file
// }

const DigitalOrderTransList = ({ permissions, ...props }) => {
    return (
        <Scrollbars>
            <List title="Digital Order Transactions" filters={<DigitalOrdersFilter permissions={permissions} />} {...props} bulkActionButtons={false}>
                <Datagrid>
                    <DateField source="order_date" showTime />
                    <TextField source="customer_name" />
                    <TextField source="transaction_number" />
                    <TextField source="product_ordered" />
                    <TextField source="mode_of_delivery" />
                    <TextField source="ordered_quantity" />
                    <TextField source="sales_order_number" />
                    <TextField source="shipment_number" />
                    <TextField source="product_type" />
                    <TextField source="processed_quantity" />
                    <TextField source="mode_of_delivery" />
                    <DateField source="expected_date" showTime />
                    <DateField source="actual_ship_date" showTime />
                    <TextField source="order_status" />
                    <TextField source="truck_details" />
                    <TextField source="load_number" />
                    <TextField source="delivery_site" />
                    <DateField source="received_date" showTime />
                </Datagrid>
            </List>
        </Scrollbars>
    );
};

export default DigitalOrderTransList;